import {useSelector} from 'react-redux';
import {useEffect, useState} from 'react';
import {AuthService} from './Service';
import {toast} from 'react-hot-toast';
import store from '../../core/store';
import {profileUpdateSuccess} from '../../core/store/auth/reducers';
import {UploadService} from '../../utils/UploadService';

const UpdateProfile = () => {
    const [service] = useState(new AuthService());
    const [uploadService] = useState(new UploadService());
    const admin = useSelector((state: any) => state.auth);
    const [name, setName] = useState(admin.name);
    const [email, setEmail] = useState(admin.email);
    const [mobile, setMobile] = useState(admin.phoneNumber);
    const [profilePic, setProfilePic] = useState(admin.profilePic);
    const [password, setPassword] = useState('');
    const [whatsapp, setWhatsapp] = useState(admin.whatsapp);
    const [addressLine1, setAddressLine1] = useState(admin.addressLine1);
    const [addressLine2, setAddressLine2] = useState(admin.addressLine2);
    const [city, setCity] = useState(admin.city);
    const [state, setState] = useState(admin.state);
    const [country, setCountry] = useState(admin.country);
    const [zipCode, setZipCode] = useState(admin.zipCode);

    const handleSubmit = async (event: any) => {
        event.preventDefault();
        const res = await service.updateProfile({
            name,
            email,
            profilePic,
            phoneNumber: mobile,
            ...(password !== '' && {password}),
            ...(whatsapp !== '' && {whatsapp}),
            ...(addressLine1 !== '' && {addressLine1}),
            ...(addressLine2 !== '' && {addressLine2}),
            ...(city !== '' && {city}),
            ...(state !== '' && {state}),
            ...(country !== '' && {country}),
            ...(zipCode !== '' && {zipCode}),
        });
        if (res != null) {
            toast.success('Profile updated successfully');
            store.dispatch({
                type: profileUpdateSuccess,
                payload: res,
            });
        }
    };

    const handleImageChange = (e: any) => {
        const file = e.target.files[0];
        if (file) {
            uploadService.upload(file).then((res) => {
                console.log(res);
                if (res.length > 0) {
                    setProfilePic(res[0]);
                    toast.success('Profile picture uploaded successfully. Please save to update profile picture');
                }
            });
        }
    };

    return (
        <form onSubmit={handleSubmit} className="row">
            <div className="col-12">
                <div className="card">
                    <div className="card-body w-100">
                        <div className="content-page-header">
                            <h5 className="setting-menu">Account Settings</h5>
                        </div>
                        <div className="row">
                            <div className="profile-picture">
                                <div className="upload-profile me-2">
                                    <div className="profile-img">
                                        <img
                                            id="blah"
                                            className="avatar"
                                            src={profilePic !== null ? profilePic : `https://ui-avatars.com/api/?background=4F6F52&color=fff&name=${name}&size=40&rounded=true`}
                                            alt="profile-img"
                                        />
                                    </div>
                                </div>
                                <div className="img-upload">
                                    <label className="btn btn-primary">
                                        Upload new picture <input type="file"
                                                                  onChange={handleImageChange}/>
                                    </label>
                                    <p className="mt-1">
                                        Image Should be minimum 152 * 152 Supported File format JPG,PNG.
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <div className="form-title">
                                    <h5>General Information</h5>
                                </div>
                            </div>
                            <div className="col-lg-6 col-12">
                                <div className="input-block mb-3">
                                    <label>Full Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter full name"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        required={true}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6 col-12">
                                <div className="input-block mb-3">
                                    <label>Email (Disabled)</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Email Address"
                                        value={email}
                                        readOnly={true}
                                        disabled={true}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required={true}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6 col-12">
                                <div className="input-block mb-3">
                                    <label>Mobile Number</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Mobile Number"
                                        value={mobile}
                                        onChange={(e) => setMobile(e.target.value)}
                                    />
                                </div>
                            </div>

                            <div className="col-lg-12">
                                <div className="input-block mb-3">
                                    <label>New Password</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter new password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                </div>
                            </div>

                            <div className="col-lg-12">
                                <div className="form-title">
                                    <h5>Contact Information</h5>
                                </div>
                            </div>

                            <div className="col-12">
                                <div className="input-block mb-3">
                                    <label>Whatsapp Number</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Enter whatsapp number"
                                        value={whatsapp}
                                        onChange={(e) => setWhatsapp(e.target.value)}
                                        required={false}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6 col-12">
                                <div className="input-block mb-3">
                                    <label>Address Line 1</label>
                                    <textarea className="form-control" rows={3} value={addressLine1}
                                              onChange={(e) => setAddressLine1(e.target.value)}/>
                                </div>
                            </div>
                            <div className="col-md-6 col-12">
                                <div className="input-block mb-3">
                                    <label>Address Line 2</label>
                                    <textarea className="form-control" rows={3} value={addressLine2}
                                              onChange={(e) => setAddressLine2(e.target.value)}/>
                                </div>
                            </div>
                            <div className="col-md-6 col-12">
                                <div className="input-block mb-3">
                                    <label>City</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter city"
                                        value={city}
                                        onChange={(e) => setCity(e.target.value)}
                                        required={false}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6 col-12">
                                <div className="input-block mb-3">
                                    <label>State</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter state"
                                        value={state}
                                        onChange={(e) => setState(e.target.value)}
                                        required={false}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6 col-12">
                                <div className="input-block mb-3">
                                    <label>Country</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter country"
                                        value={country}
                                        onChange={(e) => setCountry(e.target.value)}
                                        required={false}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6 col-12">
                                <div className="input-block mb-3">
                                    <label>Zip Code</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Enter zip code"
                                        value={zipCode}
                                        onChange={(e) => setZipCode(e.target.value)}
                                        required={false}
                                    />
                                </div>
                            </div>

                            <div className="col-lg-12">
                                <div className="btn-path text-end">
                                    <a
                                        href="javascript:void(0);"
                                        className="btn btn-cancel bg-primary-light me-3"
                                        onClick={() => {
                                            setName(admin.name);
                                            setEmail(admin.email);
                                            setMobile(admin.phoneNumber);
                                            setPassword('');
                                            setProfilePic(admin.profilePic);
                                        }}
                                    >
                                        Cancel
                                    </a>
                                    <button type="submit" className="btn btn-primary">
                                        Save Changes
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </form>
    );
};

export default UpdateProfile;
